import React from 'react';
import classnames from 'classnames';

import type { INewMarkType } from '@home/types/common';

import '@home/components/NewMarkIcon/index.scss';

interface INewMarkIconProps {
  type?: INewMarkType;
  className?: string;
  style?: React.CSSProperties;
}

const getNewMarkText = (type?: INewMarkType): string => type === 1 ? 'BETA' : 'NEW';

const NewMarkIcon: React.FC<INewMarkIconProps> = (props) => {
  const { type = 0, style, className } = props;

  return <span style={style} className={classnames('dbh-new-tag', className)}>{getNewMarkText(type)}</span>;
};

export default React.memo(NewMarkIcon);
